import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class RemoveEmptyPersona extends Action<StorymapState> {
    public static ACTION_TYPE = 'RemoveEmptyPersona';

    public constructor() {
        super(RemoveEmptyPersona.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState): void => {
    state.personas = state.personas.filter(x => !x.isNew);
};

//@ts-ignore
registerReducer(RemoveEmptyPersona.ACTION_TYPE, reducer);
